import { defineComponent as _defineComponent } from 'vue'
import { PropType } from 'vue';
import { TranslateResult } from 'vue-i18n';


export default /*#__PURE__*/_defineComponent({
  __name: 'SettingsGroup',
  props: {
  title: { type: [String, Object] as PropType<string|TranslateResult>, required: false, default: '' },
  subtitle: { type: [String, Object] as PropType<string|TranslateResult>, required: false, default: '' },
  hideDivider: { type: Boolean, required: false, default: false },
  gutter: { type: Boolean, required: false, default: false },
  gutterMd: { type: Number, required: false, default: 10 },
  gutterLg: { type: Number, required: false, default: 8 },
  gutterXl: { type: Number, required: false, default: 6 },
},
  setup(__props) {

const props = __props;



return { __sfc: true,props }
}

})